export const getCustomerDetailsLink = (customerID, greenInvoiceClientID) => {
  return Boolean(greenInvoiceClientID)
    ? `/customer-details/${customerID}/${greenInvoiceClientID}`
    : `/customer-details/${customerID}/notGiClient`
    ;
};
